import {
  ADD_ADMIN_REQUEST,
  ADD_ADMIN_SUCCESS,
  ADD_ADMIN_FAILURE,
  UPDATE_ADMIN_REQUEST,
  UPDATE_ADMIN_SUCCESS,
  UPDATE_ADMIN_FAILURE,
  DELETE_ADMIN_REQUEST,
  DELETE_ADMIN_SUCCESS,
  DELETE_ADMIN_FAILURE,
  GET_PROFILE_REQUEST,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAILURE,
} from "../constants/adminConstant.js";

//About Reducer
const adminIntialState = {
  home: null,
  admin: null,
  loading: false,
  error: null,
};

export const adminReducer = (state = adminIntialState, action) => {
  switch (action.type) {
    // case ADD_HOMEPAGE_REQUEST:
    //   return { ...state, loading: true, error: null };
    // case ADD_HOMEPAGE_SUCCESS:
    //   return { ...state, loading: false, home: action.payload };
    // case ADD_HOMEPAGE_FAILURE:
    //   return { ...state, loading: false, error: action.payload };
    case ADD_ADMIN_REQUEST:
      return { ...state, loading: true, error: null };
    case ADD_ADMIN_SUCCESS:
      return { ...state, loading: false, admin: action.payload };
    case ADD_ADMIN_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case UPDATE_ADMIN_REQUEST:
      return { ...state, loading: true, error: null };
    case UPDATE_ADMIN_SUCCESS:
      return { ...state, loading: false, admin: action.payload };
    case UPDATE_ADMIN_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case DELETE_ADMIN_REQUEST:
      return { ...state, loading: true, error: null };
    case DELETE_ADMIN_SUCCESS:
      return { ...state, loading: false, admin: action.payload };
    case DELETE_ADMIN_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case GET_PROFILE_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_PROFILE_SUCCESS:
      return { ...state, loading: false, profile: action.payload };
    case GET_PROFILE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
